import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SessionStateService } from '../../../core/services/session-state.service';

@Component({
  selector: 'app-delete-user-dialog',
  templateUrl: './delete-user-dialog.component.html',
  styleUrls: ['./delete-user-dialog.component.scss']
})
export class DeleteUserDialogComponent implements OnInit {
  @Output() action: EventEmitter<boolean> = new EventEmitter<boolean>();
  email: string;
  constructor(
    public dialogRef: MatDialogRef<DeleteUserDialogComponent>,
    private sessionStateService: SessionStateService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.email = data.email;
      dialogRef.disableClose = true;
    }

  ngOnInit() {
    document.getElementById('unfocus').classList.add('unfocus');
  }

  onCloseDialog() {
    document.getElementById('unfocus').classList.remove('unfocus');
    this.dialogRef.close();
  }

  delete() {
    this.action.emit(true);
    this.onCloseDialog();
  }

  cancel() {
    this.action.emit(false);
    this.onCloseDialog();
  }

  getHouseName() {
    return this.sessionStateService.getHouse().name;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/profile/delete-user-dialog/delete-user-dialog.component.ts